import { useMemo } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
import './favorites.scss';
import { useGetFavoriteResults } from '../../api/search.ts';
import { useGetCurrentUser } from '../../hooks/auth.ts';
import { useGetFavorites, useGetHomeModelFavorites } from '../../api/favorites.ts';
import { useGetHomeDesigns, useGetHomeModelsByIds } from '../../api/homes.ts';
import { extractIdOfSK } from '../../utils/search.ts';
import { useTitle } from '../../hooks/useTitle.ts';
import { ResultsList } from './ components/results-list/results-list.tsx';
import { SavedHomeDesignsResultList } from './ components/saved-home-designs-results-list/saved-home-designs-results-list.tsx';
import { SavedHomeModelResultList } from './ components/saved-home-model-result-list/saved-home-model-result-list.tsx';

export const SavedSearchView = () => {
  useTitle('Favorites - Immersive Homes');

  const user = useGetCurrentUser();

  // TODO: Add error handling
  const { data: favoritesData, loading } = useGetFavorites(
    user.data?.userId || ''
  );

  //TODO: To avoid making multiple calls we should return full property data from the favorites response
  const { data: favorites, pending } = useGetFavoriteResults(
    favoritesData || []
  );
  const { data: homeModelsFavorites } = useGetHomeModelFavorites();
  const favoritesIds = useMemo(
    () =>
      homeModelsFavorites
        ? homeModelsFavorites
            .map((HmFav) => extractIdOfSK(HmFav.sk))
            .filter((id): id is string => id !== null && id !== undefined)
        : [],
    [homeModelsFavorites]
  );

  // TODO: Migrate to new services API
  // TODO: Add error handling and loading states
  const { data: homeModelsData } = useGetHomeModelsByIds(favoritesIds);
  // TODO: Migrate to new services API
  // TODO: Add error handling and loading states
  const { data: savedHomeDesigns } = useGetHomeDesigns();

  const sortedFavorites = useMemo(() => {
    return [...favorites].sort((a, b) => {
      if (a?.moveForward === b?.moveForward) return 0;
      return a?.moveForward ? -1 : 1;
    });
  }, [favorites]);

  const showSpinner = loading || pending;

  return (
    <Box data-testid="saved-search-page" className="favorites-page">
      <Box className="container">
        <Box>
          {showSpinner ? (
            <Box className="loading-contained">
              <CircularProgress sx={{ marginRight: '12px' }} />
              <Typography>Loading...</Typography>
            </Box>
          ) : (
            <>
              {(!savedHomeDesigns || savedHomeDesigns.length === 0) &&
              (!homeModelsData || homeModelsData.results?.length === 0) &&
              (!favoritesData || favoritesData.length === 0) ? (
                <Box className="no-results">
                  <Typography className="no-results-text">
                    No favorites found
                  </Typography>
                </Box>
              ) : (
                <>
                  <SavedHomeModelResultList
                    homeModels={homeModelsData?.results}
                    homeModelsFavorites={homeModelsFavorites}
                  />
                  <SavedHomeDesignsResultList homeDesigns={savedHomeDesigns} />
                  <ResultsList favorites={sortedFavorites} />
                </>
              )}
            </>
          )}
        </Box>
      </Box>
    </Box>
  );
};
